module.exports = __webpack_public_path__ + "img/card_eden_exit.d961b77b.svg";